export const CITATION_WIDGET = 'citation-widget'
export const CREATE_NEW_CITATION = 'create-new-citation'
